import { postAsync } from './_base';

const postLogin = (email?: string, password?: string, loginApiUrl?: string) => {
  return postAsync(loginApiUrl ?? '', undefined, {
    username: email,
    password: password,
  });
};

export { postLogin };